<template>
  <div class="info">
    <template v-if="total_count === 0">{{ t('features.vue.pagination.no_orders_found') }}</template>
    <template v-else-if="isLessThanLimit">
      {{ t('features.vue.pagination.displaying_all', { count: total_count }) }}
    </template>
    <template v-else>
      {{ t('features.vue.pagination.displaying', { from: from, to: last_page ? total_count : to, total_count: total_count }) }}
    </template>
  </div>
</template>

<script>
export default {
  inject: ['i18n'],

  props: {
    initialData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      total_count: 0,
      current_page: 1,
      per_page: 25,
      last_page: false,
      from: 0,
      to: 0,
      ...this.initialData
    }
  },

  watch: {
    initialData: {
      handler(newVal) {
        Object.keys(newVal).forEach((key) => {
          this[key] = newVal[key]
        })
      },
      deep: true
    }
  },

  computed: {
    isLessThanLimit() {
      return this.total_count < this.per_page
    }
  },

  methods: {
    t(key, options) {
      return this.i18n.t(key, options)
    }
  }
}
</script>
